// import stripe from 'stripe';
// const stripe = require('@stripe/stripe-js')('sk_test_ko1Hp1CX04FKgXaIS0apbeGj00shEk58oU');
import { Elements } from '@stripe/react-stripe-js';
import OnDemandCheckout from 'components/OnDemandCheckout';
import ClassConfirmation from 'components/ClassConfirmation';
import ClassList from 'components/ClassList';
import React, {useEffect} from "react";
import { useLocation } from "react-router-dom";
// import AsyncStripeProvider from 'util/AsyncStripeProvider';
import { StripeProvider } from 'react-stripe-elements';
import { Route, Switch, useRouter } from "util/router.js";
import OfferingList from 'components/OfferingList'
import OfferingCheckout from 'components/OfferingCheckout';
import OfferingConfirmation from 'components/OfferingConfirmation';
import OnDemandListSection from './OnDemandList';
import { useSelector, useDispatch } from 'react-redux';
import {useWidget} from 'util/widget'
import { fetchInstructorData } from 'store/actions/widgetActions';


// / A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function OnDemandWidget(props) {
    const { match, stripe, challengeid, ondemand, products } = props;

    const instructor = useSelector(state => state.widget.instructor);
    const userData = useSelector(state => state.user.userData)
    const dispatch = useDispatch()

    const widget = useWidget()
    React.useEffect(() => {
        // console.log("useWidget: ", widget)
        if (widget && widget.widgetName) {
            dispatch(fetchInstructorData(widget.widgetName, "videos"));
        }
    }, [dispatch, widget.widgetName])
    return (
    <>
        <Switch>
            <Route 
                path={`${match.url}/confirm/:platformID`}
                render={props => {
                    return  (<>
                        <ClassConfirmation {...props} />
                    </>)
                    
                }} 
            />
            <Route
                path={`${match.url}/checkout/:platformID`} 
                render={props => {
                    
                    return (<>
                    <StripeProvider stripe={stripe} >
                        <Elements stripe={stripe} >
                            <OnDemandCheckout challengeid={challengeid} {...props} />
                        </Elements>
                    </StripeProvider>
                    </>)
                }}
            />
            <Route
                path={`${match.url}`}
                render={props => {
                    return (<>
                        <OnDemandListSection ondemand={ondemand} products={products} challengeid={challengeid} {...props}/>
                    </>)
                }}>
                
            </Route>
        </Switch>
    </>
    )
}

export default OnDemandWidget;